// Shared process step constants
export const STEP_SELECT_TYPE = 'select-type';
export const STEP_SUCCESS = 'success';
export const STEP_INFO = 'info';
export const STEP_CONFIRM = 'confirm';

// Base step type that can be extended by specific processes
export type BaseProcessStep = typeof STEP_SELECT_TYPE | typeof STEP_SUCCESS | typeof STEP_INFO | typeof STEP_CONFIRM;

// Process-specific step combinations
export type StandardProcessSteps = typeof STEP_SELECT_TYPE | typeof STEP_SUCCESS | typeof STEP_INFO;

export type ImportProcessSteps = typeof STEP_SELECT_TYPE | typeof STEP_INFO | typeof STEP_CONFIRM;
